<template>
<header class="app-header navbar">
  <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
  <b-link class="navbar-brand" to="#"></b-link>
  <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">&#9776;</button>
  <b-nav is-nav-bar class="ml-auto mr-3">
    <b-nav-item-dropdown right>
      <template slot="button-content">
        <img src="//www.gravatar.com/avatar/?d=mysteryman&s=200" class="img-avatar" alt="admin@bootstrapmaster.com">
        <span class="d-md-down-none">{{ user.name }}</span>
      </template>
      <b-dropdown-item  :to="{ name: 'profile' }"><i class="fa fa-user"></i> Perfil</b-dropdown-item>
      <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</header>
</template>
<script>
export default {
  name: 'theheader',
  data() {
    return {
      user: this.$auth.user()
    }
  },
  methods: {
    logout() {
      this.$auth.logout()
      this.$router.push({
        name: 'login'
      })
    },
    sidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?0a625c7e